import { render } from "./FooterPage.vue?vue&type=template&id=5b1c1f03&ts=true"
import script from "./FooterPage.vue?vue&type=script&lang=ts"
export * from "./FooterPage.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/autoatendimento.totalvia.com.br/TotemAtendimento/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__